import { render, staticRenderFns } from "./LayoutCustomerSidenav.vue?vue&type=template&id=39436396"
import script from "./LayoutCustomerSidenav.vue?vue&type=script&lang=js"
export * from "./LayoutCustomerSidenav.vue?vue&type=script&lang=js"
import style0 from "./LayoutCustomerSidenav.vue?vue&type=style&index=0&id=39436396&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports